module.exports = __webpack_public_path__ + "assets/img/08b.f96c6ba9.jpg";